import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {Grid, Box, Button, Select, MenuItem} from '@material-ui/core';
import { LoadingButton } from '@mui/lab';
import SaveIcon from '@mui/icons-material/Save';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import Alert from '@mui/material/Alert';
import axios from 'axios';
import Cookies from 'js-cookie';
import {API_URL} from '../utils/EnvVars';
import { func } from 'prop-types';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => {    
  const [open, setOpen] = React.useState(false);


  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  

	
  function redirectTo(){
    window.location.href='selectcourse?cid='+props.courseId;
  }

  return (
    <>
      {/* <Button title={"Save "+testTypeLabel+" & Exit"} onClick={handleClickOpen} variant="contained" color="primary" >Save & Exit</Button> */}
      <Dialog fullWidth aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle >
          <span style={{color:'#FF0000'}}>Alert</span>
        </DialogTitle>

        <DialogContent dividers style={{minHeight:150}} >
            <div className="dialogSubmitTestBox">
              {!window.navigator.onLine?
              <p style={{color:'#FF0000',fontWeight:'bold',minHeight:60, padding: 20}}>
                It seems, you are not connected to the internet.
              </p>
              :
              <>
              <Box>
                <h2 style={{color:'#FF0000'}}>You have already attempted free trial test</h2>
                <h2 style={{color:'#0000FF'}} >You must upgrade your account to give more tests</h2>
              </Box>

              <Button onClick={() => { redirectTo() }} variant="contained" style={{backgroundColor:'#008000',color:'#FFFFFF',marginTop:30}} >Upgrade Now</Button>
                
                           
              </>
              }
            </div>
        </DialogContent>

        

      </Dialog>
    </>
  );

});

export default CustomizedDialogs;
